import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import Login from '@/pages/Login/Login';
import ErrorPage from '@/pages/Error/Error';
// Core
import TypographyPage from '@/pages/Typography/Typography';

// Tables
import TablesBasicPage from '@/pages/Tables/Basic';

// Maps
import GoogleMapPage from '@/pages/Maps/Google';

// Main
import AnalyticsPage from '@/pages/Dashboard/Dashboard';

// Main
import VideosPrincipal from '@/pages/VideosPrincipal/VideosPrincipal';

// Main
import CDCCreateNew from '@/pages/CDCCreateNew/CDCCreateNew';

// Documents
import Documentos from '@/pages/Documentos/Documentos';

// Charts
import ChartsPage from '@/pages/Charts/Charts';

// CDC Charts
import CDCChartsPage from '@/pages/CDCCharts/CDCCharts';

// Ui
import IconsPage from '@/pages/Icons/Icons';
import NotificationsPage from '@/pages/Notifications/Notifications';

//MENTENIMIENTOS
import ABCAgencias from '@/pages/abc/abcAgencias';
import ABCEmpresas from '@/pages/abc/abcEmpresas';
import ABCLocales from '@/pages/abc/abcLocales';
import ABCUsuarios from '@/pages/abc/abcUsuarios';
 
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/app',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: 'videosPrincipal',
          name: 'VideosPricipal',
          component: VideosPrincipal,
        },
        {
          path: 'newCDC',
          name: 'newCDC',
          component: CDCCreateNew,
        },

        {
          path: 'documentos',
          name: 'Documentos',
          component: Documentos,
        },

        {
          path: 'dashboard',
          name: 'AnalyticsPage',
          component: AnalyticsPage,
        },
        {
          path: 'typography',
          name: 'TypographyPage',
          component: TypographyPage,
        },
        {
          path: 'components/icons',
          name: 'IconsPage',
          component: IconsPage,
        },
        {
          path: 'notifications',
          name: 'NotificationsPage',
          component: NotificationsPage,
        },
        {
          path: 'components/charts',
          name: 'ChartsPage',
          component: ChartsPage,
        },
        {
          path: 'components/cdccharts',
          name: 'CDCChartsPage',
          component: CDCChartsPage,
        },
        {
          path: 'tables',
          name: 'TablesBasicPage',
          component: TablesBasicPage,
        },
        {
          path: 'components/maps',
          name: 'GoogleMapPage',
          component: GoogleMapPage,
        },

        //MANTENIMIENTOS
        {
          path: 'abcempresas',
          name: 'ABCEmpresas',
          component: ABCEmpresas,
        },
        {
          path: 'abclocales',
          name: 'ABCLocales',
          component: ABCLocales,
        },
        {
          path: 'abcusuarios',
          name: 'ABCUsuarios',
          component: ABCUsuarios,
        },
        

      ],
    },
  ],
});
